$(document).ready(function() {

	$(".nav-toggle").click(function (e) {
		$(this).toggleClass('active');
		$('.side-header').toggleClass('active');
	})

});